const chunkArray = (array: any[], chunkSize = 10, result = [] as any[][]): any[][] => {
  if (array.length === 0) {
    return result;
  }

  return chunkArray(array.slice(chunkSize), chunkSize, result.concat([array.slice(0, chunkSize)]));
};

export default chunkArray;
